import { render, staticRenderFns } from "./個人保有.vue?vue&type=template&id=c28f2a0a&"
import script from "./個人保有.ts?vue&type=script&lang=ts&"
export * from "./個人保有.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports